import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { NumericFormatProps } from 'react-number-format';
import { Button } from './Button';
import { NumberInput } from './NumberInput';

interface Props {
  disabled?: boolean;
  name?: string;
  onChange: (newValue: number) => void;
  value: number | '';
}

export const QuantityPicker: React.FC<Props> = ({
  disabled,
  name,
  onChange,
  value,
}) => {
  const handleIncrement = () => onChange((value || 0) + 1);

  const handleChange: NumericFormatProps['onValueChange'] = v =>
    onChange(v.floatValue || 0);

  const handleDecrement = () => {
    if ((value || 0) > 0) {
      onChange((value || 0) - 1);
    }
  };

  return (
    <div className="inline-flex space-x-2">
      <Button
        disabled={disabled}
        variant="outlined"
        color="grey"
        className="w-10 !px-0"
        onClick={handleDecrement}
      >
        <MinusIcon className="mx-auto h-5 w-5" />
      </Button>

      <NumberInput
        disabled={disabled}
        className="w-14"
        id={name}
        name={name}
        inputClassName="px-1 text-center"
        value={value == null ? '' : value || 0}
        onFocus={e => e.target.select()}
        onValueChange={handleChange}
      />

      <Button
        disabled={disabled}
        variant="outlined"
        color="grey"
        className="w-10 !px-0"
        onMouseDown={handleIncrement}
      >
        <PlusIcon className="mx-auto h-5 w-5" />
      </Button>
    </div>
  );
};
